export default __webpack_public_path__ + "static/brush-stroke-peach-aa2f884696a2f41289526730f0759fa3.svg";